module.exports = __webpack_public_path__ + "img/ukasko-bonus.56582dce.svg";